/* PURE SKY - Before/After Comparison Slider */

// ========================================
// COMPARISON SLIDER
// ========================================

function initComparisonSlider() {
  const sliders = document.querySelectorAll('.comparison-slider');
  
  sliders.forEach(slider => {
    const afterImage = slider.querySelector('.comparison-slider__image--after');
    const handle = slider.querySelector('.comparison-slider__handle');
    const knob = slider.querySelector('.comparison-slider__knob');
    
    if (!afterImage || !handle || !knob) return;

    let isDragging = false;
    let currentPosition = 50; // Start at 50%
    
    // Get initial position from data attribute if set
    const initialPosition = slider.getAttribute('data-initial-position');
    if (initialPosition) {
      currentPosition = parseFloat(initialPosition);
      updateSliderPosition(currentPosition);
    }

    // ========================================
    // UPDATE SLIDER POSITION
    // ========================================
    
    function updateSliderPosition(percentage) {
      // Clamp between 0 and 100
      percentage = Math.max(0, Math.min(100, percentage));
      currentPosition = percentage;
      
      // Update clip-path for after image
      afterImage.style.clipPath = `inset(0 0 0 ${percentage}%)`;
      
      // Update handle position
      handle.style.left = `${percentage}%`;
    }

    // ========================================
    // MOUSE EVENTS
    // ========================================
    
    function handleMouseMove(e) {
      if (!isDragging) return;
      
      const rect = slider.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const percentage = (x / rect.width) * 100;
      
      updateSliderPosition(percentage);
    }

    function handleMouseDown(e) {
      isDragging = true;
      slider.classList.add('dragging');
      handleMouseMove(e);
      e.preventDefault();
    }

    function handleMouseUp() {
      isDragging = false;
      slider.classList.remove('dragging');
    }

    // ========================================
    // TOUCH EVENTS
    // ========================================
    
    function handleTouchMove(e) {
      if (!isDragging) return;
      
      const rect = slider.getBoundingClientRect();
      const x = e.touches[0].clientX - rect.left;
      const percentage = (x / rect.width) * 100;
      
      updateSliderPosition(percentage);
      e.preventDefault();
    }

    function handleTouchStart(e) {
      isDragging = true;
      slider.classList.add('dragging');
      handleTouchMove(e);
    }

    function handleTouchEnd() {
      isDragging = false;
      slider.classList.remove('dragging');
    }

    // ========================================
    // KEYBOARD NAVIGATION
    // ========================================
    
    function handleKeyDown(e) {
      let moved = false;
      
      switch(e.key) {
        case 'ArrowLeft':
          currentPosition = Math.max(0, currentPosition - 2);
          moved = true;
          break;
        case 'ArrowRight':
          currentPosition = Math.min(100, currentPosition + 2);
          moved = true;
          break;
        case 'Home':
          currentPosition = 0;
          moved = true;
          break;
        case 'End':
          currentPosition = 100;
          moved = true;
          break;
      }
      
      if (moved) {
        updateSliderPosition(currentPosition);
        slider.setAttribute('data-keyboard-active', 'true');
        e.preventDefault();
      }
    }

    function handleBlur() {
      slider.setAttribute('data-keyboard-active', 'false');
    }

    // ========================================
    // CLICK TO POSITION
    // ========================================
    
    function handleClick(e) {
      // Only handle clicks directly on the slider, not on the knob
      if (e.target === knob || knob.contains(e.target)) return;
      
      const rect = slider.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const percentage = (x / rect.width) * 100;
      
      updateSliderPosition(percentage);
    }

    // ========================================
    // EVENT LISTENERS
    // ========================================
    
    // Mouse events
    knob.addEventListener('mousedown', handleMouseDown);
    slider.addEventListener('mousedown', handleClick);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    // Touch events
    knob.addEventListener('touchstart', handleTouchStart, { passive: false });
    slider.addEventListener('touchstart', (e) => {
      if (e.target === knob || knob.contains(e.target)) return;
      const rect = slider.getBoundingClientRect();
      const x = e.touches[0].clientX - rect.left;
      const percentage = (x / rect.width) * 100;
      updateSliderPosition(percentage);
    });
    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    document.addEventListener('touchend', handleTouchEnd);

    // Keyboard events
    slider.addEventListener('keydown', handleKeyDown);
    slider.addEventListener('blur', handleBlur);
    
    // Make slider focusable
    slider.setAttribute('tabindex', '0');
    
    // ========================================
    // RESPONSIVE - UPDATE ON RESIZE
    // ========================================
    
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateSliderPosition(currentPosition);
      }, 100);
    });

    // ========================================
    // CLEANUP ON DESTROY
    // ========================================
    
    slider.comparisonSliderCleanup = () => {
      knob.removeEventListener('mousedown', handleMouseDown);
      slider.removeEventListener('mousedown', handleClick);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      
      knob.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
      
      slider.removeEventListener('keydown', handleKeyDown);
      slider.removeEventListener('blur', handleBlur);
    };
  });
}

// ========================================
// IMAGE LOADING
// ========================================

function initComparisonSliderImages() {
  const sliders = document.querySelectorAll('.comparison-slider');
  
  sliders.forEach(slider => {
    const images = slider.querySelectorAll('.comparison-slider__image');
    let loadedCount = 0;
    const totalImages = images.length;
    
    if (totalImages === 0) return;
    
    slider.classList.add('loading');
    
    images.forEach(img => {
      if (img.complete) {
        loadedCount++;
        if (loadedCount === totalImages) {
          slider.classList.remove('loading');
        }
      } else {
        img.addEventListener('load', () => {
          loadedCount++;
          if (loadedCount === totalImages) {
            slider.classList.remove('loading');
          }
        });
        
        img.addEventListener('error', () => {
          console.error('Failed to load comparison image:', img.src);
          loadedCount++;
          if (loadedCount === totalImages) {
            slider.classList.remove('loading');
          }
        });
      }
    });
  });
}

// ========================================
// INITIALIZE
// ========================================

document.addEventListener('DOMContentLoaded', () => {
  initComparisonSliderImages();
  initComparisonSlider();
  
  console.log('PURE SKY - Before/After Comparison Slider initialized ✓');
});

// Cleanup on page unload
window.addEventListener('beforeunload', () => {
  const sliders = document.querySelectorAll('.comparison-slider');
  sliders.forEach(slider => {
    if (slider.comparisonSliderCleanup) {
      slider.comparisonSliderCleanup();
    }
  });
});
